import React from 'react';
import { BundleOnChangeParams, CardBundle, Bundle, Product, DetailedListBundle, ListBundle, BundleComponentProps } from '@tripadd/components';
import { initializePaymentSummary, updateBookNowAmount } from '../../booking/payment-summary/payment-summary';

interface ITripAddBundleWidgetProps {
    bundle: Bundle;
    preSelected: Product[];
    renderMode: 'CardBundle' | 'DetailedListBundle' | 'ListBundle'
}
export const TripAddBundleWidget = ({ renderMode, bundle, preSelected }: ITripAddBundleWidgetProps) => {
    const onChangeHandler = (params: BundleOnChangeParams) => {
        updateBundle(params);
    }
    const bundleProp: BundleComponentProps = {
        fontWeights: { normal: "400", medium: "500", bold: "600" },
        primaryColor: "#0060BB",
        secondaryColor: "#FBB321",
        bundle: bundle,
        preSelectedProducts: preSelected,
        onChange: onChangeHandler
    }
    switch (renderMode) {
        case 'CardBundle':
            return React.createElement(CardBundle, bundleProp)
        case 'DetailedListBundle':
            return React.createElement(DetailedListBundle, bundleProp)
        case 'ListBundle':
            return React.createElement(ListBundle, bundleProp)
        default:
            return React.createElement(CardBundle, bundleProp)

    }
}

export const updateBundle = (params: BundleOnChangeParams) => {
    const token = $('input[name="__RequestVerificationToken"]', '.active-details-panel').val()
    const bookingId = $('input[name="BookingId"]').val()
    const passengers: {
        passengerTypeCode: string,
        productIds: string[]
    }[] = []
    Object.keys(params.passengerPurchases).forEach(key => passengers.push({
        passengerTypeCode: key,
        productIds: params.passengerPurchases[key]
    }))

    const bundleItemModel = {
        passengers: passengers,
        price: params.price,
        retailPrice: params.retailPrice
    }
    $('#wait-total-price').addClass('-with-wait-indicator');
    $('#reviewAndPayButton').prop("disabled", true);
    $.ajax({
        url: "/FlightBooking/BundleItems",
        method: "POST",
        dataType: "html",
        data: {
            __RequestVerificationToken: token,
            bookingId,
            bundleItemModel
        },
        success: function (result) {
            $('#paymentSummaryRightPanel').html(result);
            updateBookNowAmount();
            initializePaymentSummary()

        },
        error: function (request, status, error) {
            console.error(request.responseText);
        },
        complete: function () {
            $('#wait-total-price').removeClass('-with-wait-indicator');
            $('#reviewAndPayButton').prop("disabled", false);
        }
    })
}

